import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { http, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await http.post("/auth/forgot-password", { email: email.trim() });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border-2 border-zinc-900 shadow-brutal p-8" data-testid="forgot-password-card">
        <div className="label-overline text-blue-600 mb-1">Account Recovery</div>
        <h1 className="font-display text-3xl font-black tracking-tighter uppercase">Forgot Password</h1>
        {done ? (
          <div className="mt-6 space-y-3" data-testid="forgot-done">
            <div className="border-l-4 border-emerald-600 bg-emerald-50 p-4 text-sm text-emerald-900">
              If an account exists for <span className="font-mono">{email}</span>, we&apos;ve sent a reset link. Check your inbox (and spam folder). The link expires in 30 minutes.
            </div>
            <Link to="/login" className="label-overline text-zinc-500 hover:text-blue-600">← Back to Sign In</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
            <p className="text-sm text-zinc-600">Enter your email — we&apos;ll send you a secure link to choose a new password.</p>
            <div>
              <label className="label-overline text-zinc-700 block mb-1">Email</label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                     data-testid="forgot-email" className="rounded-none border-zinc-400" />
            </div>
            <Button type="submit" disabled={busy} data-testid="forgot-submit"
                    className="w-full rounded-none h-11 bg-blue-600 hover:bg-blue-700 text-white font-mono uppercase tracking-widest text-xs">
              {busy ? "Sending…" : "Send Reset Link"}
            </Button>
            <div className="text-center pt-2">
              <Link to="/login" className="label-overline text-zinc-500 hover:text-blue-600">← Back to Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
